import * as React from 'react'
import * as StoresActions from '../../../../actions/stores'
import { useAppSelector } from '../../../../reducers'
import type Store from '../../../../types/StoreMain'
import { useAppDispatch } from '../../../../actions/types';

interface StoreOption {
    key: string;
    value: string;
}

interface UseDisplayStoresProps {
    currentValues: string[];
    search?: string;
}


export default function useDisplayStores({ currentValues = [], search = ''}: UseDisplayStoresProps): StoreOption[] {
    const dispatch = useAppDispatch()
    const stores = useAppSelector<Store[]>(state => state.stores.list)

    React.useEffect(() => {
        dispatch(
            StoresActions.fetchStoresPaginated({
                search,
                showEmptyStores: true,
            })
        )
    }, [dispatch, search])    

    return React.useMemo(() => {
        const lowerSearch = search.toLowerCase()

        return stores.filter(store => {
            const alreadyIncluded = currentValues.includes(store.code)
            const matchesPartialSearch = store.code.toLowerCase().includes(lowerSearch)
                || store.name.toLowerCase().includes(lowerSearch)

            return !alreadyIncluded && matchesPartialSearch
        }).sort((a, b) => {
            return a.name.localeCompare(b.name)
        }).map((store) => ({
            key: store.code,
            value: `${store.code} ${store.name}`,
        }))
    }, [currentValues, search, stores])
}
